import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import Global from '../../../store/global-selectors';
import * as OrdersActions from '../../../store/orders/orders.actions';
import * as Actions from './orders.selected-orders.actions';

export const updateDrawerOrdersAfterAddressValidation = (action$, { getState }) =>
  action$.pipe(
    ofType(OrdersActions.GET_ORDERS_SUCCESS),
    mergeMap((action) => {
      const { orders: ids } = action;
      const lookupHash = ids.reduce(
        (acc, id) => ({
          ...acc,
          [id]: id,
        }),
        {},
      );

      const state = getState();
      const selectedIds = Global.selectSelectedOrdersIds(state);
      const newSelectedIds = selectedIds.filter((id) => !!lookupHash[id]);
      if (JSON.stringify(selectedIds) === JSON.stringify(newSelectedIds)) {
        return EMPTY;
      }

      return of(Actions.setSelectedOrdersPreCheck(newSelectedIds));
    }),
  );
